import React from 'react';
import { Header } from 'semantic-ui-react';

export default () => (
  <Header as='h2' icon inverted textAlign='center' className='title'>
      <Header.Subheader>
      © 2020 Vlad Burlutskiy
      </Header.Subheader>
  </Header>

);

